import { useState } from "react";
import { circles } from "@/mocks/homeData";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function CirclesSection() {
  const [followed, setFollowed] = useState<string[]>(["circle-02"]);

  const toggleFollow = (id: string) => {
    setFollowed((prev) => (prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]));
  };

  return (
    <section id="circles" className="w-full border-t border-background-200 bg-background-100/60 py-16 md:py-20">
      <div className="mx-auto w-full px-4 md:px-8">
        <div className="flex flex-col justify-between gap-5 md:flex-row md:items-end">
          <SectionHeading
            eyebrow="Circles · 圈子分区"
            title="按圈层进入，讨论更集中"
            desc="把同一类爆料收进同一个圈子，圈内按事件成立话题，进入即可看到同好正在讨论的完整脉络。"
          />
          <a
            href="#topics"
            className="flex items-center gap-2 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            查看全部 186 个圈子
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {circles.map((circle) => {
            const isFollowed = followed.includes(circle.id);
            return (
              <article
                key={circle.id}
                className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
              >
                <div className="relative h-44 w-full overflow-hidden bg-background-200">
                  <img
                    src={circle.cover}
                    alt={`${circle.name} 圈子 黑料社区`}
                    title={`${circle.name} 圈子 黑料社区`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  {circle.hot ? (
                    <span className="absolute left-3 top-3 flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
                      <span className="flex h-3 w-3 items-center justify-center">
                        <i className="ri-fire-fill"></i>
                      </span>
                      热议中
                    </span>
                  ) : null}
                  <span className="absolute right-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-medium text-foreground-700 backdrop-blur">
                    {circle.tag}
                  </span>
                </div>

                <div className="flex flex-1 flex-col p-5">
                  <h4 className="font-heading text-lg font-bold text-foreground-950">{circle.name}</h4>
                  <p className="mt-1 text-xs font-medium text-primary-600">{circle.tagline}</p>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{circle.desc}</p>

                  <div className="mt-4 flex items-center gap-4 border-t border-background-200 pt-4 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <span className="flex h-3.5 w-3.5 items-center justify-center">
                        <i className="ri-user-3-line"></i>
                      </span>
                      {circle.members}
                    </span>
                    <span className="flex items-center gap-1">
                      <span className="flex h-3.5 w-3.5 items-center justify-center">
                        <i className="ri-chat-3-line"></i>
                      </span>
                      {circle.posts} 话题
                    </span>
                    <span className="ml-auto flex items-center gap-1 text-primary-600">
                      <span className="flex h-3.5 w-3.5 items-center justify-center">
                        <i className="ri-fire-line"></i>
                      </span>
                      {circle.heat}
                    </span>
                  </div>

                  <button
                    type="button"
                    onClick={() => toggleFollow(circle.id)}
                    className={`mt-4 flex h-10 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors ${
                      isFollowed
                        ? "bg-primary-100 text-primary-700"
                        : "bg-foreground-950 text-background-50 hover:bg-foreground-800"
                    }`}
                  >
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className={isFollowed ? "ri-check-line" : "ri-add-line"}></i>
                    </span>
                    {isFollowed ? "已关注圈子" : "关注圈子"}
                  </button>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}